"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityPartialUpdateBuilder = void 0;
var tslib_1 = require("tslib");
var PartialUpdateBuilder_1 = require("./PartialUpdateBuilder");
var message = tslib_1.__importStar(require("../message"));
var intersection_1 = require("../intersection");
var EntityPartialUpdateBuilder = /** @class */ (function (_super) {
    tslib_1.__extends(EntityPartialUpdateBuilder, _super);
    /**
     * @param entity
     * @param operations
     */
    function EntityPartialUpdateBuilder(entity, operations) {
        var _this = _super.call(this, operations) || this;
        _this.entity = entity;
        return _this;
    }
    /**
     * @inheritDoc
     */
    EntityPartialUpdateBuilder.prototype.execute = function () {
        var _this = this;
        var state = intersection_1.Metadata.get(this.entity);
        var body = JSON.stringify(this);
        var msg = new message.UpdatePartially(state.bucket, state.key, body);
        return state.withLock(function () { return (state.db.send(msg).then(function (response) {
            // Update the entity’s values
            state.type.fromJsonValue(state, response.entity, _this.entity, { persisting: true });
            return _this.entity;
        })); });
    };
    return EntityPartialUpdateBuilder;
}(PartialUpdateBuilder_1.PartialUpdateBuilder));
exports.EntityPartialUpdateBuilder = EntityPartialUpdateBuilder;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRW50aXR5UGFydGlhbFVwZGF0ZUJ1aWxkZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJFbnRpdHlQYXJ0aWFsVXBkYXRlQnVpbGRlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7O0FBQUEsK0RBQThEO0FBRTlELDBEQUFzQztBQUV0QyxnREFBMkM7QUFFM0M7SUFBa0Usc0RBQXVCO0lBQ3ZGOzs7T0FHRztJQUNILG9DQUE0QixNQUFTLEVBQUUsVUFBbUI7UUFBMUQsWUFDRSxrQkFBTSxVQUFVLENBQUMsU0FDbEI7UUFGMkIsWUFBTSxHQUFOLE1BQU0sQ0FBRzs7SUFFckMsQ0FBQztJQUVEOztPQUVHO0lBQ0gsNENBQU8sR0FBUDtRQUFBLGlCQVlDO1FBWEMsSUFBTSxLQUFLLEdBQUcsdUJBQVEsQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDO1FBQ3hDLElBQU0sSUFBSSxHQUFHLElBQUksQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDLENBQUM7UUFDbEMsSUFBTSxHQUFHLEdBQUcsSUFBSSxPQUFPLENBQUMsZUFBZSxDQUFDLEtBQUssQ0FBQyxNQUFNLEVBQUUsS0FBSyxDQUFDLEdBQUksRUFBRSxJQUFJLENBQUMsQ0FBQztRQUV4RSxPQUFPLEtBQUssQ0FBQyxRQUFRLENBQUMsY0FBTSxPQUFBLENBQzFCLEtBQUssQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDLElBQUksQ0FBQyxVQUFDLFFBQVE7WUFDL0IsNkJBQTZCO1lBQzdCLEtBQUssQ0FBQyxJQUFJLENBQUMsYUFBYSxDQUFDLEtBQUssRUFBRSxRQUFRLENBQUMsTUFBTSxFQUFFLEtBQUksQ0FBQyxNQUFNLEVBQUUsRUFBRSxVQUFVLEVBQUUsSUFBSSxFQUFFLENBQUMsQ0FBQztZQUNwRixPQUFPLEtBQUksQ0FBQyxNQUFNLENBQUM7UUFDckIsQ0FBQyxDQUFDLENBQ0gsRUFOMkIsQ0FNM0IsQ0FBQyxDQUFDO0lBQ0wsQ0FBQztJQUNILGlDQUFDO0FBQUQsQ0FBQyxBQXpCRCxDQUFrRSwyQ0FBb0IsR0F5QnJGO0FBekJZLGdFQUEwQiJ9